<template>
  <result-wrapper :element-data="elementData"
                  :flag-name="isTwitter ? 'bi bi-twitter-x' : ''">
    <div class="markup-container">
      <div>
        <h5 class="card-title ellipsis" v-html="elementData.standard.title"></h5>

        <markup-link :resultData="elementData.standard"
                     :resultType="elementData.resulttype">{{ formatUrl }}</markup-link>

        <div class="rating-box" v-if="'starrating' in elementData.standard">
          <div class="rating" :style='"width:" + elementData.standard.starrating.value + "%"'></div>
        </div>
      </div>
      <!-- A real thumbnail only. The `|| fallbackLogo` that used to be here rendered the
           carousel logo, and this <img> is a COLUMN child (`.markup-container` gets
           `flex-direction: column` when it has no `.markup-container-with-image`), so the
           logo stacked BELOW the two text lines and pushed the row past the fixed 44px
           `.result-container` height — a tall blank box with a scrollbar. The social logo
           belongs in the flag slot on the left, which is where production draws it. -->
      <img v-if="elementData.standard.img" class="ms-3 rounded" :src="elementData.standard.img" alt="">
    </div>
  </result-wrapper>
</template>

<script>
import MarkupLink from "@/components/card/MarkupLink.vue";
import ResultWrapper from "@/components/card/ResultWrapper.vue";
import commonUtil from "@/utils/commonUtil";

export default {
  name: "TwitterBox",
  props: {
    elementData: Object,
  },
  components: {
    MarkupLink,
    ResultWrapper,
  },
  data() {
    return {
    }
  },
  computed: {
    formatUrl() {
      const re = /(\?|&)ref_src.*/i;
      const url = this.elementData.standard.url;
      let fUrl = url ? url.replace(re, '') : '';
      return this.urlForDisplay(fUrl);
    },
    // The flag is the X mark at the left edge of the row — the only social logo this
    // result type is supposed to draw. Matching the literal string 'twitter' missed
    // every `https://x.com/...` result, so the flag vanished on exactly the URLs the
    // rebrand produces. The parser's own test for this type (`_is_social_x_url` in
    // browsers-web-service `mongo_transformer.py`) anchors on the netloc for both
    // domains; mirror that, otherwise a row is classified as a twitterbox and then
    // rendered without the mark that identifies it.
    isTwitter() {
      const host = commonUtil.extractDomain(this.elementData.standard.url) || '';
      return /(^|\.)(twitter\.com|x\.com)$/i.test(host);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

// This <img> is UNCONSTRAINED without a cap, and it is a COLUMN child: `.markup-container`
// takes `flex-direction: column` whenever it lacks `.markup-container-with-image`
// (_markup.scss), so whatever lands here stacks BELOW the title and link rather than beside
// them, inside a `.result-container` pinned to 44px. Sibling components escape this by
// nesting their <img> in `.image-wrapper`, whose `img { max-width/height: 100% }` contains
// it; nothing contained this one. An oversized source therefore pushed the row past its
// fixed height and produced a scrollbar (seen on tid 156539, NHL).
//
// Bounded to the icon scale rather than the row height: at row height the image SETS the
// row height instead of sitting inside it.
.markup-container > img {
  max-height: var(--result-container-title-icon-width-regular);
  max-width: var(--result-container-title-icon-width-regular);
  width: auto;
  height: auto;
  object-fit: contain;
  flex-shrink: 0;
}

.medium-view {
  .fa-twitter {
    width: 0.65rem;
  }

  .markup-container > img {
    max-height: var(--result-container-title-icon-width-medium);
    max-width: var(--result-container-title-icon-width-medium);
  }
}
</style>
